import React, { useState } from 'react';
import { useCart } from '@/contexts/CartContext';
import { Badge } from '@/components/ui/badge';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Clock, ChevronDown } from 'lucide-react';

export default function StoreStatus({ compact = false }) {
  const { storeStatus, getScheduleInfo } = useCart();
  const [open, setOpen] = useState(false);
  const schedule = getScheduleInfo();

  if (compact) {
    return (
      <div className="flex items-center gap-2">
        <div
          className={`w-2 h-2 rounded-full animate-pulse ${
            storeStatus.isOpen ? 'bg-green-500' : 'bg-red-500'
          }`}
        />
        <span className="text-xs text-pizzaria-text-secondary hidden sm:inline">
          {storeStatus.isOpen ? 'Aberto' : 'Fechado'}
        </span>
      </div>
    );
  }

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button className="flex items-center gap-2 hover:opacity-80 transition-opacity">
          <Badge
            className={`${
              storeStatus.isOpen
                ? 'bg-green-500/20 text-green-500 border-green-500/30'
                : 'bg-red-500/20 text-red-500 border-red-500/30'
            } cursor-pointer`}
          >
            <div
              className={`w-2 h-2 rounded-full mr-2 animate-pulse ${
                storeStatus.isOpen ? 'bg-green-500' : 'bg-red-500'
              }`}
            />
            {storeStatus.isOpen ? 'Aberto' : 'Fechado'}
            <ChevronDown className="w-3 h-3 ml-1" />
          </Badge>
        </button>
      </PopoverTrigger>
      <PopoverContent
        className="w-[min(92vw,20rem)] bg-pizzaria-bg border-white/10 p-4"
        align="start"
      >
        <div className="space-y-3">
          <div className="flex items-center gap-2 pb-2 border-b border-white/10">
            <Clock className="w-4 h-4 text-primary" />
            <span className="font-heading text-sm text-white uppercase">
              Horários
            </span>
          </div>
          
          <div className="grid grid-cols-2 gap-2 text-xs">
            {schedule.map((day, index) => (
              <div
                key={index}
                className={`rounded-lg border border-white/10 px-2 py-2 flex flex-col gap-1 ${
                  day.isOpen
                    ? 'text-pizzaria-text-secondary'
                    : 'text-pizzaria-text-muted'
                }`}
              >
                <span className="font-semibold text-[11px] uppercase tracking-wide">{day.day}</span>
                <span className={`leading-tight ${day.isOpen ? '' : 'text-red-400/70'}`}>
                  {day.hours}
                </span>
              </div>
            ))}
          </div>

          <div className="pt-2 border-t border-white/10">
            <p className="text-xs text-pizzaria-text-muted">
              {storeStatus.message}
            </p>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
}
